export const getCountOnline = (items, typeDisponible) =>{
    //console.log(items)
    //console.log(typeDisponible)
    let onlineObj= {
        countOnline: 1,
        countOffline: 0
    }
    if(typeDisponible === 'DOCTOR'){
        if(!items[0].online){
            onlineObj.countOnline = 0
            onlineObj.countOffline = 1
            return onlineObj
        }else{
            return onlineObj
        }
    }else{
        let filteredArr = items.reduce((acc, current) => {
            const x = acc.find(item => item.id === current.id);
            if (!x) {
              return acc.concat([current]);
            } else {
              return acc;
            }
          }, []);

         // console.log(filteredArr)


        let online = filteredArr.filter(e=>e.online)
        let offline = filteredArr.length - online.length
        onlineObj.countOnline = online.length
        onlineObj.countOffline = offline
        return onlineObj
    }
}